module.exports = __webpack_public_path__ + "static/media/hiv_racial_breakdown.54ed2bd3.jpg";